export const getLevelPrefix = (isLevelCustomized) => {
    return isLevelCustomized ? "C" : "L";
};
export const isLevelAttained = (inhibitors, level) => {
    for (let index = 1; index <= level; index++) {
        if (inhibitors.requirements[index])
            return false;
    }
    return true;
};
export const getBestLevel = (inhibitors) => {
    if (Object.keys(inhibitors.requirements).length === 0)
        return 5;
    const sortedRequirements = Object.keys(inhibitors.requirements).sort();
    return parseInt(sortedRequirements[0]) - 1;
};
export const getLevelInfo = ({ status, enabled = true, policyLevel, scanLevel, }) => {
    if (scanLevel === 0 || policyLevel === 0)
        return "";
    if (status === "fail" && policyLevel === 1)
        return "";
    if (status === "fail") {
        return `Will PASS:L${policyLevel - 1}`;
    }
    else {
        if (policyLevel <= scanLevel)
            return `${enabled ? "Suppressed" : "Disabled"} FAIL:L${policyLevel}`;
        else
            return `Will FAIL:L${policyLevel}`;
    }
};
//# sourceMappingURL=levels.js.map